import styled from '@emotion/native';
import { BodyText } from '@/shared/components/StyledText';
import { green } from '@/shared/styles/colors';

export const SectionContainer = styled.View({
  marginVertical: 16,
});

export const SectionHeader = styled(BodyText)({
  fontSize: 16,
  fontWeight: 'bold',
  color: green,
});
